export const MODULES = [
  'departures',
  'arrivals',
  'trafficSituations',
  'vehicle',
  'extendedInformation',
] as const;
export type Module = (typeof MODULES)[number];
